<template>
  <div class="mains">
    <div class="tiyouimg">
      <img src="../assets/img/sxs/sxsjs1.png" alt="">
    </div>
<!--    <div style="width: 70%;margin: 66px 15%;display: flex;align-items: center;flex-direction: column">-->

<!--    </div>-->
    <div class="bj1" style="margin-top: 76px;width: 100%;height:auto;display: flex;justify-content: center;align-items: center;flex-direction: column">
      <div style=";display: flex;justify-content: center;align-items: center;flex-direction: column;width: 67%;height: 100%;justify-content: center">
        <div style="font-size: 25px;
          height: 33px;
          font-weight: bold;
          color: #1F2D5D;
          margin-bottom: 80px;
          line-height: 18px;">
          详情介绍/DETAILS
        </div>

        <div style="width:100%;display: flex;justify-content: space-between">
          <div style="width: 66%">
            <img  src="../assets/img/sxs/sxsjs2.png" alt="">
          </div>
          <div style="width: 33%">
            <img src="../assets/img/sxs/sxsjs3.png" alt="">
          </div>

        </div>
        <div style="width:100%;display: flex;justify-content: space-between;margin-top: 5px">
          <div style="width: 18.8%">
            <img  src="../assets/img/sxs/sxsjs4.png" alt="">
          </div>
          <div style="width: 35.1%">
            <img src="../assets/img/sxs/sxsjs5.png" alt="">
          </div>

          <div style="width: 43.6%">
            <img src="../assets/img/sxs/sxsjs6.png" alt="">
          </div>

        </div>
        <div style="width: 100%;margin-top: 88px;display: flex;justify-content: space-between">
            <div style="width: 29.5%;">
              <img style="height: 100%" src="../assets/img/sxs/sxsjs7.png" alt="">
            </div>

            <div style="width: 69.8%;display:flex;justify-content: space-between" >
              <div style="width: 49.4%;display: flex;flex-direction: column;justify-content: space-between">
                <img style="height: 49%" src="../assets/img/sxs/sxsjs8.png" alt="">
                <img style="height: 49%" src="../assets/img/sxs/sxsjs9.png" alt="">
              </div>
              <div style="width:49.4%;display: flex;flex-direction: column;justify-content: space-between">
                <img style="height: 49%" src="../assets/img/sxs/sxsjs10.png" alt="">
                <img style="height: 49%" src="../assets/img/sxs/sxsjs11.png" alt="">
              </div>
            </div>
        </div>

        <div style="width: 54px;height: 11px;margin-top: 60px">
          <img src="../assets/img/sxs/sxs12.png" alt="">
        </div>
      </div>

    </div>

    <div class="second_content_four" style="width: 100%;display: flex;
    justify-content: center;align-items: center;position: relative">
      <div style="width: 76%;margin: 60px 15%;display: flex;
    justify-content: center;align-items: center;flex-direction: column;overflow: no-content;
    ">
        <div style="font-size: 25px;
          height: 33px;
          font-weight: bold;
          color: #1F2D5D;
          line-height: 18px;">
          案例展示/CASE SHOW
        </div>
        <div style="width: 100%;height: auto;margin-top: 30px;padding: 0 30px;position: relative">
          <div class="swiper-container" ref="swps">
            <div class="swiper-wrapper">
              <div
                  class="swiper-slide lunbopic"
                  :list="list"
                  v-for="item in list"
                  :key="item.id"
              >
                <img  @mouseenter="imgchange($event)" @mouseleave="imgchange2($event,)" :src="item.src" alt="" />
              </div>
            </div>
          </div>
          <!-- 如果需要导航按钮 -->
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.min.css'
import Swiper from 'swiper'
export default {
  name: "Sxs",
  components: {
    Swiper
  },
  data(){
    return{
      list:[
      ],
      changeFlag:true,
    }
  },
  created() {
    this.initpic()
  },
  computed: {
    mySwiper() {
      // mySwiper 是要绑定到标签中的ref属性
      return this.$refs.swps.swiper
    },
  },
  mounted() {
    /* eslint-disable no-new */
    setTimeout(()=>{
      this.swiper()//防止第一张图闪过
    },500)
  },
  methods: {
    swiper(){
      new Swiper('.swiper-container', {
        slidesPerView: 3,
        spaceBetween : 5,
        loop: true,
        // 如果需要分页器
        pagination: '.swiper-pagination',
        // 如果需要前进后退按钮
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        // 如果需要滚动条
        // scrollbar: '.swiper-scrollbar',
        // 如果需要自动切换海报
        //speed:4000,
        autoplay: 2000,
        autoplayDisableOnInteraction: false,
        observer:true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,//修改swiper的父元素时，自动初始化swiper
      })
    },
    //初始化图片
    initpic(){
      for (let i = 1; i < 10; i++) {
        this.list.push({id:i,src:require("../assets/img/room/cjcl"+i+".png")})
      }
    },
    //图片放大
    imgchange(val){
      console.log(val)
      this.mySwiper.stopAutoplay();
      val.currentTarget.className='large';
      // const lgimg =  document.getElementsByClassName("second_content_four::before")[0]
      // lgimg.style.display = "block"
      //lgimg.style.background="background: rgba(0,0,0,.4)  url(\""+srcs.src+"\") no-repeat center center;display: block;"
    },
    imgchange2(val){
      this.mySwiper.startAutoplay();
      val.currentTarget.className='column'
    }
  }
}
</script>

<style lang="scss" scoped>
.imgbott{
  margin: 4px 4px;
}
.bj1{
  //background-image: url(../assets/img/sxs/sxjs12.png) ;
  background-repeat: no-repeat;
  background-size: 50% 100%;
}
img{
  width: 100%;
  height: auto;
  max-height: 100%;
  transition: all .4s;
}
.mains{
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: white;
  flex-direction: column;
  display: flex;
  align-items: center;
.tiyouimg{
  width: 100%;
}
}
.imgbott1{
  margin: 4px 4px;
}
.imgmar{
  margin: 4px 4px;
}
.lunbopic{
  //height: 342px;
  img{
    width: 100%;
    height: auto;
    max-height: 100%;
  }
}
.swiper-container{
  position: relative;
  width: 100%;
  height: 100%;
}

/*去掉默认样式*/
.swiper-button-prev:after{
  display: none;
}
.swiper-button-next:after{
  display: none;
}
/*自定义样式*/
.swiper-button-prev{
  position: absolute;
  background-color: #fff;
  width: 51px;
  height: 51px;
  border-radius: 50%;
  font-size: 16px;
  background-size: 30% 30%;/*按比例缩放*/
  top: 50%;
  left: 0.8%;
  box-shadow: 0 0 10px #888888;
}

.swiper-button-next{
  position: absolute;
  background-color: #fff;
  width: 51px;
  height: 51px;
  border-radius: 50%;
  background-size: 30% 30%;/*按比例缩放*/
  top: 50%;
  right: 0.8%;
  box-shadow: 0 0 10px #888888;
}
.swiper-container .swiper-wrapper{
  -webkit-transition-timing-function: linear; /*之前是ease-out*/
  -moz-transition-timing-function: linear;
  -ms-transition-timing-function: linear;
  -o-transition-timing-function: linear;
  transition-timing-function: linear;
}
.large{
  transform: scale(1.06);
  img{
    z-index: 99999
  };
}
.column{
  transform: scale(1);
  transition: transform 1s ease 0s;
}

.second_content_four::before{
  content: '';
  display: none;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0,0,0,.4)  url("../assets/img/about/about1.png") no-repeat center center;//可以加图片什么的;
  z-index:999;
  background-size:50% auto;
}
//.second_content_four:hover::before{
//  display: block;
//}
</style>
